class Data extends HTMLElement {

  connectedCallback () {
    this.hidden = true;
  }

  get value () {
    return JSON.parse(this.textContent);
  }

}

customElements.define('d-data', Data);
